import { useState, useMemo, useRef } from 'react';
import { Box, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import floorPlanImage from '../../Assets/Images/UnitSelection/BuildingSelectionImg.jpg';

const BuildingSelection = () => {
  const navigate = useNavigate();
  const location = useLocation();
   const {  paymentId, tokenNo } = location.state || {};

   console.log('Payment ID:', paymentId);
    console.log('Token Number:', tokenNo);

 const wingMapping = {
    1: 'A1',
    2: '',
    3: 'A2',
    4: 'B2',
    5:'B1',
  };
   const wingMappingMobile = {
    1: 'B2',
    2: 'B1',
    3: 'A1',
    4: '',
    5:'A2',
  };
  // Your exported multi-path "d" from Figma
  const RAW_D = `
  M1638 418.6475C1646.6325 397.8351 1653.6626 387.996 1671.5 375.647461L1777 480.147C1777 480.147 1757.095 511.467 1769.5 530.647V620.147H1707.5H1635.5V544.147H1659V539.147H1643.5V530.647V509.647H1635.5V480.147H1643.5V447.1475L1635.5 451.6475V418.6475
M1818.56 433.5C1837.05 416.852 1848.19 414.145 1859.56 422.5M1859.56 433.5H1965.56V285.5H1881.56V307.5H1875.56V293.5H1843.56V285.5H1823.56V293.5H1783.5601V285.5H1751.5601V293.5C1725.3045 309.415 1713.121 317.586 1710.56 326.5L1813.56 433.5
M870.5 700.68V557.67969H957.5V565.6797C977.216 568.9044 988.463 569.4252 1011.5 550.679688L1116.5 660.68C1100.217 673.543 1091.02 679.829 1074.5 689.68V700.68H1039.5V694.68H1006.5V700.68H981.5V694.68H950.5V680.68H944.5V700.68H870.5Z

M1211.621 370.5H1065.620605V457.5H1076.6206C1080.521 482.14 1076.447 493.541 1065.620605 512.5L1167.621 617.5C1183.415 604.212 1190.253 595.035 1197.621 574.5H1211.621V541.5H1204.621V504.5H1211.621V481.5H1204.621V452.5H1191.621V447.5H1211.621V370.5Z
  `;

const RAW_D_MOBILE = `
  M312.5 722.68V579.67969H399.5V587.6797C419.216 590.9044 430.463 591.4252 453.5 572.679688L558.5 682.68C542.217 695.543 533.02 701.829 516.5 711.68V722.68H481.5V726.68H448.5V722.68H423.5V726.68H392.5V702.68H386.5V722.68H312.5Z
M600.621 622.5H454.620605V709.5H465.6206C469.5211 734.14 465.447 745.541 454.620605 764.5L556.621 869.5C572.415 856.212 579.253 847.035 586.621 826.5H600.621V793.5H593.621V756.5H600.621V733.5H593.621V704.5H580.621V699.5H600.621V622.5Z
M461 1053.6475C469.6325 1032.8351 476.6626 1022.996 494.5 1010.647461L600 1115.147C600 1115.147 580.095 1146.467 592.5 1165.647V1255.147H520.5H448.5V1179.147H472V1174.147H456.5V1165.647V1144.647H448.5V1115.147H456.5V1082.1475L448.5 1086.6475V1053.6475

M605.56 1303.5C624.05 1283.852 635.19 1281.145 656.56 1292.5M656.56 1303.5H742.56V1152.5H668.56V1177.5H662.56V1160.5H630.56V1152.5H610.56V1160.5H570.5601V1152.5H538.5601V1160.5C512.304 1166.415 500.321 1174.5862 496.560059 1193.5L600.56 1303.5
`;
  // 1) Split multi-subpath into separate <path>s
  const subpaths = useMemo(() => {
    const parts = RAW_D.match(/M[^M]+/g) || [];
    return parts.map((d, i) => ({
      id: i + 1,
      name: `Unit ${i + 1}`,
      d: d.trim(),
    }));
  }, [RAW_D]);

  const subpathsMobile = useMemo(() => {
    const parts = RAW_D_MOBILE.match(/M[^M]+/g) || [];
    return parts.map((d, i) => ({
      id: i + 1,
      name: `Unit ${i + 1}`,
      d: d.trim(),
    }));
  }, [RAW_D]);

  // State for hover and selected unit
  const [hoverId, setHoverId] = useState(null);
  const [selectedWing, setSelectedWing] = useState(null);
  const selectedWingRef = useRef(null);


  // Navigate to the Tokens page
  const handleGoBack = () => {
    navigate('/Home/Tokens');
  };


  const handleUnitClick = (p, isSelected) => {
    const newWing = isSelected ? null : (isMobile ? wingMappingMobile[p.id] : wingMapping[p.id]);
    selectedWingRef.current = newWing; // Update the ref

    console.log('Selected Wing:', newWing);
    console.log('Is Selected:', isSelected);
    console.log('Path ID:', p.id);

    //config wing id here for each wing and pass it to next page

    const wingIdMapping = { 
      B1:'146a0491-a004-4562-bce2-f63a8890d834',
      B2: '146a0491-a004-4562-bce2-f63a8890d834', 
      A1:'25a202bc-a854-4b39-a07d-4322d1c1a7fe', 
      A2: '25a202bc-a854-4b39-a07d-4322d1c1a7fe'
    }

    const selectedWingId = newWing ? wingIdMapping[newWing] : null;

    console.log('Selected Wing ID:', selectedWingId);

    // Now navigate with the wing name as state
    navigate("/Home/UnitFloorMap", {
      state: { paymentId:paymentId, tokenNo:tokenNo, wingName: newWing, wingId:selectedWingId },
    });

    console.log(newWing); // Log to verify the wing name
  };
  // Media query to detect mobile view
  const isMobile = useMediaQuery('(max-width:600px)');



  return (
    <Box sx={{ width: '100%', overflow: 'auto' ,backgroundColor:'#FFF1E6',}}>
      {/* Go Back To Tokens Button */}
      <Box
        onClick={handleGoBack}
        sx={{
          display: 'inline-block',
          fontSize: { xs: 14, sm: 14 },
        //   padding: 3,
          fontWeight: 600,
          textTransform: 'uppercase',
          background: 'linear-gradient(90deg, #0072ff 0%, #00b4e6ff 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          cursor: 'pointer',
          position: 'relative',
          letterSpacing: 0.5,
          '&::after': {
            content: '""',
            position: 'absolute',
            left: 0,
            bottom: -3,
            width: '100%',
            height: 2,
            background: 'linear-gradient(90deg, #0072ff, #00b4e6ff)',
            transform: 'scaleX(0)',
            transformOrigin: 'right',
            transition: 'transform 0.3s ease',
          },
          '&:hover::after': {
            transform: 'scaleX(1)',
            transformOrigin: 'left',
          },
        }}>
        ← Go Back To Token
      </Box>

      {/* Floor Plan with SVG paths */}
      <Box sx={{ width: '100%', height: 'auto', paddingTop: 3 }}>
        <svg
          width="100%"
          height="100%"
          viewBox={isMobile?"0 0 800 2057":"0 0 2563 1257"}
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <image
            href={floorPlanImage}
            x="-150"
            y="-30"
            width="100%"
            height="100%"
            preserveAspectRatio="xMidYMid meet"
           
            style={{
              transition: 'transform 0.3s ease', // Smooth transition
              transform: isMobile ? 'rotate(90deg)scale(1.9)' : 'none', // Rotate on mobile view
              transformOrigin: 'center center', // Keep the center of the image as the rotation point
               
            }}
          />
        {isMobile ?( subpathsMobile.map((p) => {
            const isHover = hoverId === p.id;
          
 const isSelected = selectedWingRef.current === wingMappingMobile[p.id];
            const fillColor = isSelected
              ? 'rgba(21,112,239,0.45)' // selected unit (blue)
              : isHover
              ? isMobile?'none':'rgba(138, 255, 134, 0.3)' // hover fill
              : 'rgba(0, 0, 0, 0.02)'; // default fill

            return (
              <g key={p.id}>
                <path
                  id={`path-${p.id}`}
                  d={p.d}
                  stroke="black"
                  strokeWidth={isSelected ? 3 : isHover ? 1 : 0}
                  fill={fillColor}
                  style={{
                    cursor: 'pointer',
                    pointerEvents: 'all',
                    transition: 'all 0.25s ease-out',
                    transformBox: 'fill-box',
                    transformOrigin: 'center',
                    transform: isSelected
                      ? 'scale(1)rotate(90deg)' // slightly scale up when selected
                      : isHover
                      ? 'scale(1)rotete(90deg)' // slightly zoom in on hover
                      : 'scale(1)rotate(90deg)', // default
                  }}
                  onMouseEnter={() => setHoverId(p.id)}
                  onMouseLeave={() => setHoverId(null)}
                   onClick={() => handleUnitClick(p, isSelected)} // toggle selection
                />
              </g>
            );
          })):
           ( subpaths.map((p) => {
            const isHover = hoverId === p.id;
         
 const isSelected = selectedWingRef.current === wingMapping[p.id];
            const fillColor = isSelected
              ? 'rgba(21,112,239,0.45)' // selected unit (blue)
              : isHover
              ? 'rgba(138, 255, 134, 0.3)' // hover fill
              : 'rgba(0, 0, 0, 0.02)'; // default fill

            return (
              <g key={p.id}>
                <path
                  id={`path-${p.id}`}
                  d={p.d}
                  stroke="black"
                  strokeWidth={isSelected ? 3 : isHover ? 1 : 0}
                  fill={fillColor}
                  style={{
                    cursor: 'pointer',
                    pointerEvents: 'all',
                    transition: 'all 0.25s ease-out',
                    transformBox: 'fill-box',
                    transformOrigin: 'center',
                    transform: isSelected
                      ? 'scale(1.5)' // slightly scale up when selected
                      : isHover
                      ? 'scale(1.45)' // slightly zoom in on hover
                      : 'scale(1.5)', // default
                  }}
                  onMouseEnter={() => setHoverId(p.id)}
                  onMouseLeave={() => setHoverId(null)}
                  onClick={() => handleUnitClick(p, isSelected)}  // toggle selection
                />
              </g>
            );
          }))}
        </svg>
      </Box>
      <Box
  sx={{
    position: 'fixed',
    bottom: isMobile ? '8vh' : '10vh',
    right: isMobile ? '8vw' : '4vw',
    width: 64,
    height: 64,
    borderRadius: '50%',
    background: 'radial-gradient(circle at 30% 30%, #fff 0%, #f1f1f1 100%)',
    boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    transform: isMobile ? 'rotate(150deg)' : 'rotate(60deg)',
  }}
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="64" height="64" >
    <circle cx="50" cy="50" r="46" fill="white" stroke="#333" strokeWidth="3" />
    <polygon points="50,40 63,80 50,67 37,80" fill="#e53935" stroke="#b71c1c" strokeWidth="2" />
    <text x="50" y="25" textAnchor="middle" fontSize="26" fontWeight="700" fill="#111" alignmentBaseline="middle">
      N
    </text>
  </svg>
</Box>

    </Box>
  );
};

export default BuildingSelection;
